<template>
  <div v-if="$page.props.flash.success && show" class="alert alert-success">
    <div class="flex">
      <div class="ml-3">
        <p class="alert-body">
          {{ $page.props.flash.success }}
        </p>
      </div>
      <div class="ml-auto pl-3">
        <div class="-mx-1.5 -my-1.5">
          <button v-on:click="show = false" type="button" class="alert-close">
            <span class="sr-only">Dismiss</span>
            <XMarkIcon class="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show" class="alert alert-danger">
    <div class="flex">
      <div class="ml-3">
        <p v-if="$page.props.flash.error" class="alert-body">
          {{ $page.props.flash.error }}
        </p>
        <p v-else class="alert-body">
          <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
          <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
        </p>
      </div>
      <div class="ml-auto pl-3">
        <div class="-mx-1.5 -my-1.5">
          <button v-on:click="show = false" type="button" class="alert-close">
            <span class="sr-only">Dismiss</span>
            <XMarkIcon class="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { usePage } from "@inertiajs/vue3";

import { XMarkIcon } from "@heroicons/vue/20/solid";

const show = ref(true);

const level = usePage().props.flash.level;
const message = usePage().props.flash.message;
</script>
